/**
 * @file   src\components\Onboarding\DeleteNotificationModalNew.js
 * @brief  This file is responsible for delete notification modal
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React from "react";
import { createPortal } from "react-dom";

const DeleteNotificationModalNew = (props) => {
  const [domReady, setDomReady] = React.useState(false);

  const divStyle = {
    display: props.show ? "flex" : "none",
  };

  React.useEffect(() => {
    setDomReady(true);
  }, []);
  return domReady
    ? createPortal(
        <div className="modal-new" style={divStyle} onFocusOut={props.onHide}>
          <div className="modal-content-new">
            <h3>Are you sure you want to delete all notifications?</h3>
            <button
              className="btn btn-confirm w-100"
              onClick={() => {
                props.onConfirm(2);
              }}
            >
              Confirm
            </button>

            <button
              variant=""
              onClick={props.onHide}
              className="btn btn-cancel w-100"
            >
              Cancel
            </button>
          </div>
        </div>,

        document.querySelector(".notif-modal-container")
      )
    : null;
};
export default DeleteNotificationModalNew;
